<template>
    <section class="tables">
        <vue-snotify></vue-snotify>
        <div class="row">
            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Member Response</h4>
                    </div>
                    <div class="card-body">
                        <vue-good-table mode="remote" :rows="rows" :columns="columns" :sort-options="{
                            enabled: false,
                        }">
                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field === 'action'" class="text-nowrap"></span>
                            </template>
                        </vue-good-table>
                    </div>
                </div>
            </div>
        </div>
        <div></div>
    </section>
</template>

<script>
import Vue from "vue";
import API from '@/api'
import SortedTablePlugin from "vue-sorted-table";

Vue.use(SortedTablePlugin, {
    ascIcon: '<i class="ti-arrow-down"></i>',
    descIcon: '<i class="ti-arrow-up"></i>'
});
export default {
    name: 'Users',
    data() {
        return {
            isDisabled: false,
            selected: true,
            unSelected: false,
            serverParams: {
                UserID: JSON.parse(localStorage.getItem('user')).UserID,
                sort: [
                    {
                        field: 'id', // example: 'name'
                        type: 'desc' // 'asc' or 'desc'
                    }
                ],

                page: 1, // what page I want to show
                perPage: 10 // how many items I'm showing per page
            },
            columns: [
                {
                    label: 'Question',
                    field: 'question',
                    sortable: false,
                },
                {
                    label: 'Answer',
                    field: 'answer',
                    sortable: false,
                },
            ],
            rows: [],
            readonly: true,
            // UserID: '',
            UserID: JSON.parse(localStorage.getItem('user')).UserID,
        };
    },

    mounted() {
        this.loadItems();
        this.loginUser = JSON.parse(localStorage.getItem('user'));
        // this.UserID = this.loginUser.UserID;
    },
    methods: {
        loadItems() {
            API.getAttemptedDetail(this.$route.params.surveyID, this.$route.params.userID,
                data => {
                    this.rows = data.data;
                }, err => {
                })
        },

    }, computed: {},
}
</script>
